import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrowRight2",
  "use": "arrowRight2-usage",
  "viewBox": "0 0 23.92961876832851 23.9479392624728",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 23.92961876832851 23.9479392624728\" fill=\"none\" id=\"arrowRight2\"><defs><rect id=\"arrowRight2_path_0\" x=\"0\" y=\"0\" width=\"23.929618768328446\" height=\"23.947939262472886\" /></defs><g opacity=\"1\" transform=\"translate(-8.526512829121202e-14 -1.1368683772161603e-13)  rotate(0 11.964809384164223 11.973969631236443)\"><mask id=\"arrowRight2_bg-mask-0\" fill=\"white\"><use xlink:href=\"#arrowRight2_path_0\" /></mask><g mask=\"url(#arrowRight2_bg-mask-0)\"><path id=\"arrowRight2_路径 1\" fill-rule=\"evenodd\" style=\"fill:#1D7045\" transform=\"translate(2.9912023460410557 5.9869848156182215)  rotate(0 8.923753661794354 5.488069410418927)\" opacity=\"1\" d=\"M14.06,4.49L0,4.49L0,6.49L14.06,6.49L10.97,9.58L12.36,10.98L17.85,5.49L12.46,0L11.07,1.4L14.06,4.49Z \" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrowRight2.svg
// module id = w0l2
// module chunks = 21